module.exports = __webpack_public_path__ + "media/images/labore-partner-a88167203e7f5c8d2d50aafc21a0f7c0.png";